module.exports = __webpack_public_path__ + "img/16order.ceeb356c.png";